import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Title from '../../common/Title';
import StyledButton from 'common/StyledButton';
import css from './LinksSection.css';
import copy from 'clipboard-copy';
import Toast from '../../common/Toast';
import { getConnectionURL, getScheduleConnectionURL } from '../../utils/deepLinks';

const LinksSection = ({personId, profileLinkAvailable, appointmentLinkAvailable}) => {

  const [showToast, setShowToast] = useState(false);

  const copyProfileLink = async () => {
    try {
      await copy(getConnectionURL(personId));
      setShowToast(true);
    } catch (e) {
      console.warn(e);
    }
  }

  const copyAppointmentLink = async () => {
    try {
      await copy(getScheduleConnectionURL(personId));
      setShowToast(true);
    } catch (e) {
      console.warn(e);
    }
  }

  return (
    <div>
      <Title text="Share Links" />
      <div className={css['buttons-container']}>
        {profileLinkAvailable && <StyledButton asLink onClick={copyProfileLink}>Copy Profile Link</StyledButton>}
        {appointmentLinkAvailable && <StyledButton asLink onClick={copyAppointmentLink}>Copy Appointment Link</StyledButton>}
        {showToast && <Toast message={"Link copied to your clipboard."} onTimeout={() => setShowToast(false)} />}
      </div>
    </div>
  );
}

LinksSection.propTypes = {
  personId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  appointmentLinkAvailable: PropTypes.bool,
  profileLinkAvailable: PropTypes.bool,
};

export default LinksSection;
